/**
* This enumeration contains the Action Type string constants for ticket list
*/
enum ActionType {
    SET_EVENT_TICKET_LIST = 'TicketListActions.SET_EVENT_TICKET_LIST',
}

export default ActionType;
